import {
  ITrackingProperties,
  ITrackingAction,
  ITrackingErrorProperties,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from './tracking.data';

// action enums
export enum ActionsEnum {
  TRACK_PAGE = 'TRACK_PAGE',
  TRACK_EVENT = 'TRACK_EVENT',
}

// action payload definitions
export interface ITrackPage {
  trackingScreenName: TrackingScreenNamesEnum;
  properties: ITrackingProperties;
}

export interface ITrackEvent {
  trackingObjects: ITrackingObject | ITrackingObject[];
  trackingAction: ITrackingAction;
  additionalProperties: ITrackingProperties;
}

export interface ITrackError {
  errorProperties: ITrackingErrorProperties;
}

// action definitions
export interface TrackPage {
  type: ActionsEnum.TRACK_PAGE;
  payload: ITrackPage;
}

export interface TrackEvent {
  type: ActionsEnum.TRACK_EVENT;
  payload: ITrackEvent;
}

// action creators
export const trackPage = (
  trackingScreenName: TrackingScreenNamesEnum,
  properties?: ITrackingProperties
): TrackPage => ({
  type: ActionsEnum.TRACK_PAGE,
  payload: {
    trackingScreenName,
    properties,
  },
});

export const trackEvent = (
  trackingObjects: ITrackingObject | ITrackingObject[],
  trackingAction: ITrackingAction,
  additionalProperties?: ITrackingProperties
): TrackEvent => ({
  type: ActionsEnum.TRACK_EVENT,
  payload: {
    trackingObjects,
    trackingAction,
    additionalProperties,
  },
});
